export default {
  'Division': {
    label: 'Production',
    compose: divisionLink,
    width: 190
  },

  'OpenCards': {
    label: 'Open Cards',
    width: 180
  },

  'ClosedCards': {
    label: 'Closed Cards',
    width: 180
  },

  'Funded': {
    label: 'Funded',
    type: 'money',
    f: 'data.Funded',
    width: 180
  },

  'Allocated': {
    label: 'Allocated to cards',
    type: 'money',
    f: 'data.Allocated',
    width: 300
  },

  'Available': {
    label: 'Available',
    type: 'money',
    f: 'data.Available',
    width: 300
  },

  'Pending': {
    label: 'Pending Amount',
    type: 'money',
    f: 'data.Pending'
  }
}

function divisionLink(p) {
  if (!p.data) return ''

  const accountId = p.data.Id

  const url = `#/d/Programs/>Card/list?AccountId=${accountId}`

  return `<a title="Open ${p.value}" href="${url}" data-action="goto">${p.value}</a>`
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-accounts/model.js